import React from "react"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export const VoteCell = ({ children, ...props }) => (
    <CellWrapper {...props}>
        {children ? (
            <Tooltip label={DjangIO.app.vote.models.VoteResultType.by_value(parseInt(children)).label}>
                <Icon name={DjangIO.app.vote.models.VoteResultType.by_value(parseInt(children, 10)).icon} />
            </Tooltip>
        ) : (
            children
        )}
    </CellWrapper>
)
export default VoteCell
